import ITask from "../../../Utility/Task/ITask";
import WorldSystem from "../WorldSystem";
import { PlayerTask } from "../../../State/Player/PlayerTasks";
import { PlayerActions } from "../../../State/Player/PlayerActions";
import WorldTaskHelper from "./WorldTaskHelper";
import { PlayerStateHelper } from "../../../State/Player/PlayerStateHelper";
import { ShowQuestProgressEvent } from "../../../Prefabs/UI/HUD/Quests/QuestButton";

export default class WorldSyncTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<number> {
        const state = system.store.getState().playerState;
        if (state.tasks.length > 0) {
            for (const taskData of state.tasks) {
                switch (taskData.task) {
                    case PlayerTask.ICON_HOP:
                        WorldTaskHelper.iconHop(system, taskData.levelNumber);
                        break;
                    case PlayerTask.FIELD_FTUX:
                        const closingTask = state.tasks.find(task => PlayerStateHelper.isClosingTask(task));
                        if (closingTask) {
                            closingTask.delay = 4000;
                        }
                        WorldTaskHelper.FTUXFieldUnlock(system, taskData);
                        break;
                    case PlayerTask.SHOW_POPUP:
                        WorldTaskHelper.ShowPopup(system, taskData);
                        break;
                    case PlayerTask.SEND_COINS:
                        WorldTaskHelper.SendCoins(system, taskData);
                        break;
                    case PlayerTask.STAR_CHEST_FTUX:
                        WorldTaskHelper.StarChestFTUX(system, taskData as { starChestLevel: number });
                        break;
                    case PlayerTask.QUESTS_FTUX:
                        WorldTaskHelper.QuestFTUX(system, taskData);
                        break;
                    case PlayerTask.SHOW_QUEST_PROGRESS:
                        system.scene.emit(ShowQuestProgressEvent, taskData);
                        break;
                    case PlayerTask.PET_WALK:
                        WorldTaskHelper.PetWalk(system, taskData);
                        break;
                    case PlayerTask.PET_FTUX:
                        WorldTaskHelper.PetUnlockFTUX(system, taskData);
                        break;
                    case PlayerTask.SHOW_WHEEL:
                        WorldTaskHelper.ShowWheel(system, taskData);
                        break;
                    case PlayerTask.WHEEL_FTUX:
                        WorldTaskHelper.WheelFTUX(system, taskData);
                        break;
                    case PlayerTask.HARVEST:
                        WorldTaskHelper.Harvest(system, taskData);
                        break;
                    case PlayerTask.FARM_BTN_FTUX:
                        WorldTaskHelper.FarmBtnFTUX(system, taskData);
                        break;
                    case PlayerTask.XMAS_FTUX:
                        WorldTaskHelper.XmasFTUX(system, taskData);
                        break;
                }
            }
            PlayerActions.clearTasks();
        }
    }
}
